import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { submit } from 'redux-form';
import './PersonalInfoPage.less';
import { FORM_ID } from '../../../../framework/App/AppConstants';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import OneColumnLayout from '../../../../framework/components/Templates/OneColumnLayout/OneColumnLayout';
import BodyHeader from '../../../../shared-components/BodyHeader/BodyHeader';
import CancelUrl, {COMPONENT_STYLE} from '../../../components/CancelUrl/CancelUrl';
import Button, {BUTTON_STYLE} from '../../../../shared-components/Button/Button';
import PropTypes from 'prop-types';
import PersonalInfoForm from './PersonalInfoForm/PersonalInfoForm';
import SoftDeclineMessage from '../../../components/SoftDeclineMessage/SoftDeclineMessage';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/PersonalInfoPage/PersonalInfoPage';
const REPAYMENT_LOCALE_PREFIX = 'DE/pages/RepaymentPage/RepaymentPage';

export class PersonalInfoPage extends Component {
    static propTypes = {
        onClickContinue: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
        showInvalidAddressSoftDecline: PropTypes.bool,
        showValidationSoftDecline: PropTypes.bool,
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        showInvalidAddressSoftDecline: false,
        showValidationSoftDecline: false,
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleClickContinue = () => {
        const { onClickContinue } = this.props;
        return onClickContinue();
    };

    handleSubmit = () => {

    };

    render() {
        const { showInvalidAddressSoftDecline, showValidationSoftDecline, intl } = this.props;
        return (
            <div className={(showInvalidAddressSoftDecline || showValidationSoftDecline) ? 'stickyHeader' : ''} >
                <OneColumnLayout pageName="PersonalInfoPage" >
                    <div className="personalInfoHeader">
                        <BodyHeader />
                        {(showInvalidAddressSoftDecline || showValidationSoftDecline) ? <SoftDeclineMessage intl={intl} /> : null}
                    </div>
                    <div className="personal-info-content">
                        <div className="alpha" id="confirm-your-info">
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.confirmYourInformation`}
                            />
                        </div>
                        <PersonalInfoForm />
                    </div>

                    <div className="buttons">
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="confirmAndApply"
                                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                id="confirmAndApplyBtn"
                                onClick={this.handleClickContinue}
                            >
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.confirmAndApply`}
                                />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: 'pp_credit_personalinfopage',
                                    transitionName: 'cancel_pp_credit_personalinfopage'
                                }}
                                customLabel={`${REPAYMENT_LOCALE_PREFIX}.cancelApplication`}
                            />
                        </div>
                    </div>
                </OneColumnLayout>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    showInvalidAddressSoftDecline: _.get(state, 'serverData.showInvalidAddressSoftDecline'),
    showValidationSoftDecline: _.get(state, 'serverData.showValidationSoftDecline')
});


export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('ppc_credit_personalinfopage', 'prepare_ppc_credit_personalinfopage'));
    },

    async onClickContinue() {
        await dispatch(submit(FORM_ID));
    },

    submitCallback(formValues, applicationType) {
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PersonalInfoPage));
